import { useContent } from "contexts/contentContext/contentContext";
import { useToasts } from "react-toast-notifications";

const RATE_LIMIT_ERROR = "rate-limit-error-global";

export const useRateLimitError = () => {
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();

  const showRateLimitError = () => {
    addToast(getTextByKey(RATE_LIMIT_ERROR), {
      appearance: "error",
    });
  };

  const isRateLimitError = (response: {
    data: string | Record<string, any>;
  }) => {
    let data = response.data;

    if (typeof data !== "string") data = JSON.stringify(data || {});

    return data.toLowerCase().includes("rate limit");
  };

  return {
    isRateLimitError,
    showRateLimitError,
    rateLimitError: getTextByKey(RATE_LIMIT_ERROR),
  };
};
